import { useEffect } from "react";
import {
  DEFAULT_FONT_PREFERENCES,
  FONT_REGIONS,
  type FontRegion,
} from "@caliu/types";
import { fontFamilyValue, fontsById } from "@caliu/styles/fonts";
import { useUIStore } from "../store/ui";

/**
 * Applies the user's font preferences to <html> as CSS variables:
 *   --font-chrome, --font-prose, --font-headings, --font-code
 *
 * These power the Tailwind tokens (`font-chrome` / `font-prose` /
 * `font-headings` / `font-code`) and the editor.css rules — themes no
 * longer set these.
 */
export function useFonts() {
  const fontPreferences = useUIStore((s) => s.fontPreferences);

  useEffect(() => {
    const root = document.documentElement;
    const fallback = fontsById[DEFAULT_FONT_PREFERENCES.regions.chrome];

    for (const region of FONT_REGIONS) {
      const id = fontPreferences.regions[region];
      const entry = fontsById[id] ?? fallback;
      root.style.setProperty(`--font-${region as FontRegion}`, fontFamilyValue(entry));
    }
  }, [fontPreferences]);
}
